module.exports = __webpack_public_path__ + "static/merch13Front-32fe0305c546aa6bab66ceb251e95513.png";